import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {UrlService} from '../../services/url.service';

@Component({
    selector: 'classifieds-filter',
    templateUrl: './classifieds-filter.component.html',
    styleUrls: ['./classifieds-filter.component.scss']
})
export class ClassifiedsFilterComponent implements OnInit {
    showDropdown = false;
    @ViewChild('residentCheckbox') resident: ElementRef;
    @ViewChild('staffCheckbox') staff: ElementRef;
    @ViewChild('approvedCheckbox') approved: ElementRef;
    @ViewChild('pendingCheckbox') pending: ElementRef;
    @ViewChild('rejectCheckbox') reject: ElementRef;
    @ViewChild('expiredCheckbox') expired: ElementRef;

    constructor(
        private urlService: UrlService
    ) {}

    ngOnInit() {
        const status = this.urlService.queryParams['status'];
        if (status) {
            this.resident.nativeElement.checked = status.indexOf('residentCheckbox') !== -1;
            this.staff.nativeElement.checked = status.indexOf('staffCheckbox') !== -1;
            this.approved.nativeElement.checked = status.indexOf('approvedCheckbox') !== -1;
            this.pending.nativeElement.checked = status.indexOf('pendingCheckbox') !== -1;
            this.reject.nativeElement.checked = status.indexOf('rejectCheckbox') !== -1;
            this.expired.nativeElement.checked = status.indexOf('expiredCheckbox') !== -1;
        }
    }

    changeFilter() {
        const residentValue = this.resident.nativeElement.checked;
        const staffValue = this.staff.nativeElement.checked;
        const approvedValue = this.approved.nativeElement.checked;
        const pendingValue = this.pending.nativeElement.checked;
        const rejectValue = this.reject.nativeElement.checked;
        const expiredValue = this.expired.nativeElement.checked;

        if (!residentValue && !staffValue && !approvedValue && !pendingValue && !rejectValue && !expiredValue) {
            this.urlService.queryParams['status'] = null;
        } else {
            let status = '';
            if (residentValue) status += 'resident,';
            if (staffValue) status += 'staff,';
            if (approvedValue) status += 'approved,';
            if (pendingValue) status += 'pending,';
            if (rejectValue) status += 'reject,';
            if (expiredValue) status += 'expired,';
            this.urlService.queryParams['status'] = status.slice(0, -1);
        }
        this.urlService.setQueryParams(null, 1);
    }

    @HostListener('document:click', ['$event.target'])
    hideDropdown(targetElement: HTMLElement): void {
        if (!targetElement.closest('classifieds-filter')) this.showDropdown = false;
    }

}



// WEBPACK FOOTER //
// /app/src/app/components/classifieds-filter/classifieds-filter.component.ts